import type { IconSvgObject } from './types';

const ElectricWireIcon: IconSvgObject = [
  ["path", { d: "M12 9H8L8 21M12 9H16V21M12 9V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 5V9M22 7H18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 7H2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 9V5C10 3.89543 9.10457 3 8 3H7M14 9V5C14 3.89543 14.8954 3 16 3H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ElectricWireIcon;
